module.exports = __webpack_public_path__ + "img/search-dark.d48c244c.svg";